// extracted by mini-css-extract-plugin
export default {"dlContainer":"styles_dlContainer__oRnxA","dropzoneText":"styles_dropzoneText__qtU0d","dropzoneSubText":"styles_dropzoneSubText__24aED"};